import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'
import { OK } from 'http-status-codes'

export class Muestras {
  static getMuestrasPorNumero (numero) {
    const axios = getAxiosInstance()
    const promise = axios.get(`listado_de_muestras_procesadas_por_numero?r=` +
    `{"clave": {"numero": ${numero}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static getMuestrasPorMuestra (muestra) {
    const axios = getAxiosInstance()
    const promise = axios.get(`listado_de_muestras_procesadas_por_muestra?r=` +
    `{"clave": {"nro_muestra": ${muestra}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static getMuestrasPorFechas (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const promise = axios.get(`listado_de_muestras_procesadas_por_fecha?r=` +
    `{"clave": {"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }
}

export function llamadoMenuMuestras (numeroDeMuestra, numeroLote) {
  return getAxiosInstance().post(
    '/consulta_registro_de_muestra', { valores: { nro_muestra: (+numeroDeMuestra), lote: numeroLote } })
}

export function deleteMuestra (numeroMuestra) {
  return getAxiosInstance().delete(
    `/consulta_registro_de_muestra?r={"clave": {"nro_muestra": ${numeroMuestra}}}`)
}

export function getDataMenuDeMuestrasTabla () {
  const axios = getAxiosInstance()
  const promise = axios.get(`/listado_de_muestras_procesadas?r={"limite":2000, "orden": ["d:fecha_de_registro"]}`)
  return promise.then(result => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo obtener el reporte de muestras.')
    return data.filas
  })
}

export function getDatoDeMuestraConCDP (numeroDeCDP) {
  const axios = getAxiosInstance()
  const promise = axios.get(`/consulta_de_muestras_listado_cdp?r={"clave": {"numero": ${numeroDeCDP}}}`)
  return promise.then(result => {
    const { status, data } = result
    if (status !== OK) throw new Error('No se pudo obtener el reporte de muestras mediante CDP.')
    return data.filas
  })
}
